export default __webpack_public_path__ + "static/media/Stocktracker2.0Logo.5487d66a.svg";